/* eslint-disable @next/next/no-page-custom-font */
import Head from "next/head";
import styles from "./index.module.css";
import { Hero } from "./Hero";
import { HowItWorks } from "./HowItWorks";
import { WhatCanIDeploy } from "./WhatCanIDeploy";
import { Templates2 } from "./Templates2";
import { FAQ2 } from "./FAQ2";
import { FinalCta } from "./FinalCta";

type Punchline = {
  pre: string;
  post: string;
  sub: string;
};

const PUNCHLINES: Punchline[] = [
  {
    pre: "you vibe-coded",
    post: "but it's still on localhost.",
    sub: "tell us what you built — we'll get it on the internet, by your side, no DevOps PhD required."
  },
  {
    pre: "you shipped it in cursor:",
    post: "now ship it to actual humans.",
    sub: "drop your repo. we handle the server, the SSL, the scary terminal stuff. you handle the launch tweet."
  },
  {
    pre: "your friend asks for the link.",
    post: "panic — it's on localhost:3000.",
    sub: "we fix that. tell us about your app and we'll walk you to a real URL — promise no kubernetes will be involved."
  },
  {
    pre: "claude wrote the code.",
    post: "we'll handle the deploy.",
    sub: "no docker, no AWS console, no crying. just chat with us, paste a repo, get a live URL in ~4 minutes."
  }
];

export const LandingPage2 = ({ punchlineIndex = 0 }: { punchlineIndex?: number }) => {
  const punchline = PUNCHLINES[punchlineIndex % PUNCHLINES.length];

  return (
    <>
      <Head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;600&display=swap"
          rel="stylesheet"
        />
      </Head>
      <div className={styles.l2}>
        <Hero punchline={punchline} />
        <HowItWorks />
        <WhatCanIDeploy />
        <Templates2 />
        <FAQ2 />
        <FinalCta />
      </div>
    </>
  );
};
